import React, { useMemo, useState } from "react";
import SearchModal from "../../components/Modals/SearchModal";
import { Sidebar, CalcList, CalcItem, MainPanel, Card, FranjaTitle, FranjaTitleMain, FranjaTitleSub } from "./Calculator.style";
import PacienteForm from "./components/PacienteForm";
import StructuredCalculatorRenderer from "./components/StructuredCalculatorRenderer";
import { calcularEdad } from "../../utils/calculatorUtils";
import calculadorasDinamicasApi from "../../api/calculadorasDinamicasApi";
import { toast } from "react-toastify";

export default function CalculadoraTFGCKD() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paciente, setPaciente] = useState(null);
  const [calculadoras, setCalculadoras] = useState([]);
  const [selectedCalculatorId, setSelectedCalculatorId] = useState(null);
  const [loadingCalculadoras, setLoadingCalculadoras] = useState(false);
  const [selectedCalculatorDefinition, setSelectedCalculatorDefinition] = useState(null);
  const [loadingDefinition, setLoadingDefinition] = useState(false);

  const loadCalculadoras = async (nextPatient) => {
    if (!nextPatient?.sexo || nextPatient?.edad === null || nextPatient?.edad === undefined) {
      setCalculadoras([]);
      setSelectedCalculatorId(null);
      return;
    }

    try {
      setLoadingCalculadoras(true);
      const rs = await calculadorasDinamicasApi.getPublicadas(
        String(nextPatient.sexo).toUpperCase(),
        nextPatient.edad
      );

      const items = rs.data || [];
      setCalculadoras(items);
      setSelectedCalculatorId(null);
      setSelectedCalculatorDefinition(null);
    } catch (error) {
      setCalculadoras([]);
      setSelectedCalculatorId(null);
      setSelectedCalculatorDefinition(null);
      toast.error("Error cargando calculadoras activas");
    } finally {
      setLoadingCalculadoras(false);
    }
  };

  const handlePacienteSelect = async (pacienteData) => {
    const nuevoPaciente = {
      nombre: pacienteData.name,
      tipoId: pacienteData.tipo,
      identificacion: pacienteData.id,
      sexo: pacienteData.raw.sexo,
      fechaNacimiento: pacienteData.raw.Fecha_Nto,
      edad: calcularEdad(pacienteData.raw.Fecha_Nto),
    };
    setPaciente(nuevoPaciente);
    setIsModalOpen(false);
    loadCalculadoras(nuevoPaciente);
  };

  const limpiarCampos = () => {
    setPaciente(null);
    setCalculadoras([]);
    setSelectedCalculatorId(null);
    setSelectedCalculatorDefinition(null);
  };

  const selectedCalculator = useMemo(
    () => calculadoras.find((item) => item.id === selectedCalculatorId) || null,
    [calculadoras, selectedCalculatorId]
  );

  const handleSelectCalculator = async (calculatorId) => {
    setSelectedCalculatorId(calculatorId);
    setSelectedCalculatorDefinition(null);

    try {
      setLoadingDefinition(true);
      const rs = await calculadorasDinamicasApi.getDefinition(calculatorId);
      if (!rs.success) {
        toast.error(rs.message || "Error cargando definición de calculadora");
        return;
      }
      setSelectedCalculatorDefinition(rs.data || null);
    } catch (error) {
      toast.error("Error cargando definición de calculadora");
    } finally {
      setLoadingDefinition(false);
    }
  };

  return (
    <div className="div-container">
      <Sidebar>
        <FranjaTitle>Calculadoras</FranjaTitle>
        <CalcList>
          {paciente ? (
            calculadoras.length > 0 ? (
              calculadoras.map((item) => (
                <CalcItem
                  key={item.id}
                  $active={selectedCalculatorId === item.id}
                  onClick={() => handleSelectCalculator(item.id)}
                >
                  {item.nombre}
                </CalcItem>
              ))
            ) : (
              <CalcItem as="div" style={{ cursor: "default" }}>
                {loadingCalculadoras ? "Cargando..." : "Sin calculadoras activas"}
              </CalcItem>
            )
          ) : (
            <CalcItem as="div" style={{ cursor: "default" }}>
              Selecciona un paciente
            </CalcItem>
          )}
        </CalcList>
      </Sidebar>

      <MainPanel>
        <Card>
          <FranjaTitle>
            <FranjaTitleMain>Datos del Paciente</FranjaTitleMain>
            <FranjaTitleSub>{paciente?.nombre || ""}</FranjaTitleSub>
          </FranjaTitle>
          <PacienteForm
            paciente={paciente}
            onBuscar={() => setIsModalOpen(true)}
            onLimpiar={limpiarCampos}
            calcularEdad={calcularEdad}
          />
        </Card>

        <Card>
          <FranjaTitle>{selectedCalculator?.nombre || "Calculadora"}</FranjaTitle>
          {selectedCalculator ? (
            loadingDefinition ? (
              <div style={{ padding: "20px", color: "#64748b" }}>Cargando definición...</div>
            ) : (
              <StructuredCalculatorRenderer
                calculator={selectedCalculatorDefinition}
                patient={paciente}
              />
            )
          ) : (
            <StructuredCalculatorRenderer calculator={null} patient={paciente} />
          )}
        </Card>

        <SearchModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSelect={handlePacienteSelect}
        />
      </MainPanel>
    </div>
  );
}
